<script lang="ts" setup>
import GwBtn from '@/components/lib/GwBtn/GwBtn.vue'
import { t } from '@/locales/i18n'
import { openChat } from '@gto/widgets/fresh-chat'
</script>

<template>
  <GwBtn
    variant="btn_large"
    style="--text-clr: var(--app-clr-primary)"
    icon="mdi-chat"
    @click="openChat()"
  >
    {{ t('common.contact_us_via_chat') }}</GwBtn
  >
</template>
